import React, { useState } from 'react'
import classNames from 'classnames'

import Numeral from 'numeral'
import { Checkbox, Section, Button, Image } from '../../../../components'
import TooltipBuyer from '../../../../components/TooltipBuyer'
import { ICONS } from '../../../../themes'

const CompareListTable = props => {
  const { quotationList = [], onOpenDescription } = props

  if (!Array.isArray(quotationList) || quotationList.length === 0) {
    return null
  }

  const suppliers =
    quotationList[0] && quotationList[0].event_item_supplier
      ? quotationList[0].event_item_supplier
      : []

  const supplierRows = React.useMemo(() => {
    return quotationList.map((item, index) => ({
      key: index,
      name: item.name,
      quantity: item.req_amount,
      uom: item.uom,
      budgetPrice: item.budget_price,
      historicalPrice: item.historical_price,
      marketPrice: item.market_price,
      suppliers: item.event_item_supplier || [],
      quotationDetail: item,
    }))
  }, [quotationList])

  const totalItemCount = quotationList.length

  const buildSavingTotalMap = list => {
    const result = {}

    list.forEach(item => {
      ;(item.event_item_supplier || []).forEach(supplier => {
        const id = supplier.supplier_id
        // result[id] = (result[id] || 0) + (supplier.saving_price || 0)
        result[id] = (result[id] || 0) + (supplier.historical_price || 0)
      })
    })

    return result
  }

  const savingTotalMap = React.useMemo(
    () => buildSavingTotalMap(quotationList),
    [quotationList]
  )

  const getTotalSavingBySupplier = supplierId => savingTotalMap[supplierId] || 0

  const formatPrice = val =>
    val !== undefined && val !== null && val !== 0
      ? Numeral(val).format('0,0')
      : '0'

  const getValue = val =>
    val !== undefined && val !== null && val !== '' ? val : 'N/A'

  const [selectedMap, setSelectedMap] = useState({})

  const toggleSelected = key => {
    setSelectedMap(prev => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  const [selectedSuppliers, setSelectedSuppliers] = useState({})

  const isSelected = key => !!selectedMap[key]

  const toggleSelectSupplier = supplierId => {
    setSelectedSuppliers(prev => {
      const nextChecked = !prev[supplierId]

      setSelectedMap(current => {
        const nextMap = { ...current }

        supplierRows.forEach(row => {
          const key = `${row.key}_${supplierId}`
          nextMap[key] = nextChecked
        })

        return nextMap
      })

      return {
        ...prev,
        [supplierId]: nextChecked,
      }
    })
  }

  return (
    <Section className="compare-list-table">
      <table className="table custom-compare-list header-freeze">
        <thead>
          <tr>
            <th className="no text-center">NO.</th>
            <th className="item">ITEM</th>

            {suppliers.map((supplier, i) => (
              <th key={supplier.supplier_id} className="supplier-name">
                <Checkbox
                  name="checkbox_supplier"
                  id={`${i}_checkbox_supplier`}
                  checked={!!selectedSuppliers[supplier.supplier_id]}
                  onChange={() => toggleSelectSupplier(supplier.supplier_id)}
                >
                  <div
                    data-tip
                    data-for={`supplier_${i}`}
                    className="truncate w-max"
                  >
                    {supplier.supplier_company_name}
                  </div>
                  <TooltipBuyer
                    id={`supplier_${i}`}
                    toolTipText={supplier.supplier_company_name}
                  />
                </Checkbox>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {supplierRows.map(row => (
            <tr key={row.key} className="supplier-item supplier-item-row">
              <td className="no">{row.key + 1}</td>
              <td className="item">
                <Section className="item-list">{row.name}</Section>
                <Section className="item-list">
                  Quantity: {formatPrice(row.quantity)} {row.uom}
                </Section>
                <Button
                  className="theme-blue front-button"
                  onClick={() => {
                    onOpenDescription && onOpenDescription(row.quotationDetail)
                  }}
                >
                  Description
                </Button>
                <Section className="item-list">
                  Budget Price: {formatPrice(row.budgetPrice)}
                </Section>
                <Section className="item-list">
                  Historical Price:
                  {formatPrice(row.historicalPrice)}
                </Section>
                <Section className="item-list">
                  Market Price: {formatPrice(row.marketPrice)}
                </Section>

                <Section style={{ marginTop: '50px' }} className="item-list">
                  <Button className="theme-gray" disabled={true}>
                    No Item Selection
                  </Button>
                  <Button className="theme-gray" disabled={true}>
                    Allocate Items
                  </Button>
                </Section>
              </td>

              {row.suppliers.map((supplier, idx) => (
                <td key={idx} className="supplier-name">
                  <Section className="supplier-item">
                    <Section className="form-row">
                      <Section className="form-col col-6">Unit Price</Section>
                      <Section className="form-col col-6">
                        {formatPrice(supplier.unit_price)}
                      </Section>
                    </Section>
                    <Section className="form-row">
                      <Section className="form-col col-6">Total Price</Section>
                      <Section className="form-col col-6">
                        {formatPrice(supplier.total_price)}
                      </Section>
                    </Section>
                    <Section className="form-row market-price">
                      <Section className="form-col col-6">Saving Price</Section>
                      <Section className="form-col col-6">
                        {/*{formatPrice(supplier.saving_price)}*/}
                        {formatPrice(supplier.historical_price)}
                      </Section>
                    </Section>
                    <Section className="form-row">
                      <Section className="form-col col-12">Note:</Section>
                      <Section className="form-col col-12">
                        <p className="line-clamp-3">
                          {getValue(supplier.note)}
                        </p>
                      </Section>
                    </Section>
                  </Section>

                  <div className="action-button-supplier">
                    <Button
                      className={classNames(
                        'is-bottom action-button-centered',
                        isSelected(`${row.key}_${supplier.supplier_id}`)
                          ? 'theme-green'
                          : 'theme-blue'
                      )}
                      onClick={() =>
                        toggleSelected(`${row.key}_${supplier.supplier_id}`)
                      }
                    >
                      {isSelected(`${row.key}_${supplier.supplier_id}`) && (
                        <Image src={ICONS['icon-check.svg']} />
                      )}
                      &nbsp;
                      {isSelected(`${row.key}_${supplier.supplier_id}`)
                        ? 'Selected'
                        : 'Select Item'}
                    </Button>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      <table className="table custom-compare-list total">
        <tbody>
          <tr className="supplier-item">
            <td className="no"></td>
            <td className="item">
              <strong>Total {totalItemCount} item</strong>
            </td>

            {suppliers.map((supplier, index) => (
              <td key={supplier.supplier_id || index} className="supplier-name">
                <Section className="form-row">
                  <Section className="form-col col-6"></Section>
                  <Section className="form-col col-6">
                    {formatPrice(
                      getTotalSavingBySupplier(supplier.supplier_id)
                    )}
                  </Section>
                </Section>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </Section>
  )
}

export default CompareListTable
